import React from 'react';
import { sanitizeHtml, SECTION_SPACING } from '../../../helpers/rendering';
import { GenericSectionContent } from '../../types';
import { useAdditionalCss } from '../../../helpers/useAdditionalCss';

/**
 * HTML Only — plain text section: renders the rich-text description from the CMS, no media.
 * Maps the legacy `section_with_heading_description` and `section_with_title_and_description`
 * blocks. Honors `content_alignment`; sanitises description HTML; supports additional_css scoping.
 */
export default function HtmlOnlyRendering({ content }: { content: GenericSectionContent }) {
  const { description, content_alignment, additional_css, additional_css_class_names } = content;
  const { uniqueClass, scopedAdditionalCss } = useAdditionalCss(additional_css, 'HtmlOnlyRendering');

  const textAlignmentClass =
    content_alignment === 'Left' ? 'text-left' : content_alignment === 'Right' ? 'text-right' : 'text-center';

  if (!description) return null;

  return (
    <>
      {scopedAdditionalCss && <style dangerouslySetInnerHTML={{ __html: scopedAdditionalCss }} />}
      <div
        className={`${SECTION_SPACING} html-only-default ${textAlignmentClass} ${[additional_css_class_names, uniqueClass].filter(Boolean).join(' ')}`}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
      />
    </>
  );
}
